import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtm from 'vue-gtm'
import firebase from 'firebase'
import 'firebase/auth'
import Home from '@/components/pages/Home'
import About from '@/components/pages/About'
import Company from '@/components/pages/Company'
import Provider from '@/components/pages/Provider'
import Live from '@/components/pages/Live'
import Admin from '@/components/pages/Admin'
import Login from '@/components/pages/Login'
import Present from '@/components/pages/202006/Present'
import Channel from '@/components/pages/202006/Channel'
import RedirectTest from '@/components/pages/202006/RedirectTest'
import Present07 from '@/components/pages/202007/Present'
import Channel07 from '@/components/pages/202007/Channel'
import RedirectTest07 from '@/components/pages/202007/RedirectTest'
import Present08 from '@/components/pages/202008/Present'
import Channel08 from '@/components/pages/202008/Channel'
import RedirectTest08 from '@/components/pages/202008/RedirectTest'
import SendaiCompany from '@/components/pages/202009sendai/SendaiCompany'
import SendaiProvider from '@/components/pages/202009sendai/SendaiProvider'
import Present10tsuruha from '@/components/pages/202010tsuruha/Present'
import Tsuruha10Company from '@/components/pages/202010tsuruha/TsuruhaCompany'
import Tsuruha10Provider from '@/components/pages/202010tsuruha/TsuruhaProvider'

Vue.use(VueRouter)
const routes = [
  {
    path: '/', redirect: '/202010/tsuruha'
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/:month',
    name: 'home',
    component: Home
  },
  {
    path: '/:month/:location',
    name: 'home',
    component: Home
  },
  {
    path: '/admin/:type',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/:month/live/:docId',
    name: 'live',
    component: Live
  },
  {
    path: '/202006/present',
    name: 'present',
    component: Present
  },
  {
    path: '/202006/channel',
    name: 'channel',
    component: Channel
  },
  {
    path: '/202006/vbtuQZNB3v&)',
    name: 'RedirectTest',
    component: RedirectTest
  },
  {
    path: '/202007/present',
    name: 'present07',
    component: Present07
  },
  {
    path: '/202007/channel',
    name: 'channel07',
    component: Channel07
  },
  {
    path: '/202007/vbtuQZNB3v&)',
    name: 'RedirectTest07',
    component: RedirectTest07
  },
  {
    path: '/202008/company',
    name: 'Company',
    component: Company
  },
  {
    path: '/202008/provider',
    name: 'Provider',
    component: Provider
  },
  {
    path: '/202008/company/:docId',
    name: 'editCompany',
    component: Company
  },
  {
    path: '/202008/provider/:docId',
    name: 'editProvider',
    component: Provider
  },
  {
    path: '/202008/present',
    name: 'present08',
    component: Present08
  },
  {
    path: '/202008/channel',
    name: 'channel08',
    component: Channel08
  },
  {
    path: '/202008/vbtuQZNB3v&)',
    name: 'RedirectTest08',
    component: RedirectTest08
  },
  {
    path: '/202009/sendai/company0915',
    name: 'SendaiCompany',
    component: SendaiCompany
  },
  {
    path: '/202009/sendai/provider0915',
    name: 'SendaiProvider',
    component: SendaiProvider
  },
  {
    path: '/202009/sendai/company0915/:docId',
    name: 'editSendaiCompany',
    component: SendaiCompany
  },
  {
    path: '/202009/sendai/provider0915/:docId',
    name: 'editSendaiProvider',
    component: SendaiProvider
  },
  {
    path: '/202010/tsuruha/present',
    name: 'present10tsuruha',
    component: Present10tsuruha
  },
  {
    path: '/202010/tsuruha/company1002',
    name: 'Tsuruha10Company',
    component: Tsuruha10Company
  },
  {
    path: '/202010/tsuruha/provider1002',
    name: 'Tsuruha10Provider',
    component: Tsuruha10Provider
  },
  {
    path: '/202010/tsuruha/company1002/:docId',
    name: 'editTsuruha10Company',
    component: Tsuruha10Company
  },
  {
    path: '/202010/tsuruha/provider1002/:docId',
    name: 'editTsuruha10Provider',
    component: Tsuruha10Provider
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    // 認証状態を取得
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        // 認証されていない場合、認証画面へ
        next({ name: 'Login' })
      }
    })
  } else {
    next()
  }
})

Vue.use(VueGtm, {
  id: 'GTM-56ML7TP',
  loadScript: true,
  vueRouter: router
})

export default router
